export default __webpack_public_path__ + "static/media/wrold.ff840496.png";